/**
 * Component: sa-shop-by-category
 * Description: Shop by category section with grid layout and hover blink effect
 */
if (!customElements.get('sa-shop-by-category')) {
  class SaShopByCategory extends HTMLElement {
    constructor() {
      super();
      this.activeTimeouts = [];
      this.initHoverBlink = this.initHoverBlink.bind(this);
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          this.initHoverBlink();
        });
      } else {
        this.initHoverBlink();
      }
    }

    disconnectedCallback() {
      this.activeTimeouts.forEach((timeout) => {
        clearTimeout(timeout);
      });
      this.activeTimeouts = [];

      if (this._hoverTargets && this._hoverEnterHandler) {
        this._hoverTargets.forEach((el) => {
          el.removeEventListener('mouseenter', this._hoverEnterHandler);
        });
        this._hoverTargets = [];
        this._hoverEnterHandler = null;
      }
    }

    initHoverBlink() {
      const imageWrappers = Array.from(this.querySelectorAll('.sa-shop-by-category__image-wrapper'));
      if (imageWrappers.length === 0) return;

      const handleEnter = (e) => {
        if (window.innerWidth < 768) return;
        const wrapper = e.currentTarget;
        const card = wrapper.closest('.sa-shop-by-category__card');
        if (!card) return;
        const titleEl = card.querySelector('.sa-shop-by-category__title');
        if (!titleEl) return;
        titleEl.classList.remove('sa-shop-by-category__title--blink');
        void titleEl.offsetWidth;
        titleEl.classList.add('sa-shop-by-category__title--blink');
        const timeout = setTimeout(() => {
          titleEl.classList.remove('sa-shop-by-category__title--blink');
        }, 1100);
        this.activeTimeouts.push(timeout);
      };

      imageWrappers.forEach((el) => {
        el.addEventListener('mouseenter', handleEnter);
      });

      this._hoverTargets = imageWrappers;
      this._hoverEnterHandler = handleEnter;
    }
  }

  customElements.define('sa-shop-by-category', SaShopByCategory);
}
